export default __webpack_public_path__ + "static/case05-72b333cf706e5895915b8e2290e37ea4.webp";